import { instance } from "./axios";
export { getArticles } from "./methods/getArticles";
export { getArticle } from "./methods/getArticle";

export const makeRequests = async (
  method,
  url,
  params) => {
    try {
      const response = await instance ({
        method: method,
        url: url,
        data: params,
      });
      //console.log("make_response", response);

      return response;
    } catch (e) {
      return Promise.reject(e);
    }
};